import React, { memo, useState, useEffect, useContext } from "react";
import { Context } from "../../../../../../store";

//scss
import "./style.scss";

//assets
import { SvgCalendar as Calendar } from "../../../../../../assets/icons/js/SvgCalendar";

//components
import { DatePicker } from "react-responsive-calendar-picker";
import moment from "moment";
import SaveClear from "../SaveClear";
import { SvgNavigationArrow } from "assets/icons/js/SvgNavigationArrow";
import { formatDate } from "helpers/dateFormatter";
import { sameDayCheckin } from "helpers/sameDayCheckin";
import { useTheme } from "components/ListingNew/ListingTheme";

const BookingDateSelect = ({
	dates,
	setDates,
	blocked,
	onClose,
	closeDrawer,
	sameDay,
	spl,
	storedDates,
}) => {
	const breakpoint = 900;
	const scaleCalendar = window.innerWidth / 50 - 5.5;
	const theme = useTheme();

	const onSave = () => {
		// dispatch({ type: "SET_DATES", payload: dates });
		//change the drawer contents to view guest details selecter
		closeDrawer();
	};

	const onClear = () => {
		setDates({
			checkin: "",
			checkout: "",
		});
	};

	return (
		<div className="booking-date-select">
			<div className="booking-date-top">
				<SvgNavigationArrow onClick={onClose} />
				<h3>Dates</h3>
			</div>
			<div className="booking-date-select__dates">
				<div className="booking-date-select__date">
					<div className="booking-date-select__date-label">
						<Calendar height={11} width={11} />
						<span className="text-xsm clr-grey">Check-in</span>
					</div>
					<div className="date-box text-sm clr-black">
						{dates.checkin
							? formatDate(moment(dates.checkin).format("DD-MMM-YYYY"))
							: ""}
					</div>
				</div>
				<span className="dash-seperator">-</span>
				<div className="booking-date-select__date">
					<div className="booking-date-select__date-label">
						<Calendar height={11} width={11} />
						<span className="text-xsm clr-grey">Check-out</span>
					</div>
					<div className="date-box text-sm clr-black">
						{dates.checkout
							? formatDate(moment(dates.checkout).format("DD-MMM-YYYY"))
							: ""}
					</div>
				</div>
			</div>
			{blocked.length !== 0 ? (
				<DatePicker
					dates={dates}
					setDates={setDates}
					open={true}
					setOpen={() => {}}
					sameDay={sameDayCheckin(sameDay) ? 1 : 0}
					mobile={window.innerWidth < breakpoint}
					blocked={blocked}
					spl={spl}
					detail={storedDates}
				/>
			) : (
				<DatePicker
					dates={dates}
					setDates={setDates}
					open={true}
					setOpen={() => {}}
					mobile={window.innerWidth < breakpoint}
				/>
			)}
			<SaveClear
				onSave={onSave}
				onClear={onClear}
				disableSave={dates.checkout && dates.checkin ? false : true}
			/>
		</div>
	);
};

export default BookingDateSelect;
